<template>
<div style="display:flex; flex-wrap:wrap;">
    <ion-button color="primary" size="small" fill="clear" v-bind:style="this.$parent.cardTemplate.energies.large['colorless']" @click="setEnergy('colorless')"></ion-button>
    <ion-button color="primary" size="small" fill="clear" v-bind:style="this.$parent.cardTemplate.energies.large['dark']" @click="setEnergy('dark')"></ion-button>
    <ion-button color="primary" size="small" fill="clear" v-bind:style="this.$parent.cardTemplate.energies.large['fighting']" @click="setEnergy('fighting')"></ion-button>
    <ion-button color="primary" size="small" fill="clear" v-bind:style="this.$parent.cardTemplate.energies.large['fire']" @click="setEnergy('fire')"></ion-button>
    <ion-button color="primary" size="small" fill="clear" v-bind:style="this.$parent.cardTemplate.energies.large['grass']" @click="setEnergy('grass')"></ion-button>
    <ion-button color="primary" size="small" fill="clear" v-bind:style="this.$parent.cardTemplate.energies.large['lightning']" @click="setEnergy('lightning')"></ion-button>
    <ion-button color="primary" size="small" fill="clear" v-bind:style="this.$parent.cardTemplate.energies.large['metal']" @click="setEnergy('metal')"></ion-button>
    <ion-button color="primary" size="small" fill="clear" v-bind:style="this.$parent.cardTemplate.energies.large['psychic']" @click="setEnergy('psychic')"></ion-button>
    <ion-button color="primary" size="small" fill="clear" v-bind:style="this.$parent.cardTemplate.energies.large['water']" @click="setEnergy('water')"></ion-button>
    <ion-button color="primary" size="small" fill="clear" v-bind:style="this.$parent.cardTemplate.energies.large['none']" @click="setEnergy('none')"></ion-button>

</div>
         
</template>

<script>
export default {
  data: function() {
    return {
     
    };
  },
  props: ['setEnergyParentFunction','setEnergyReference'],
  methods: {
       setEnergy: function (energy) {
           // Do your stuff
           console.log("yahoo", energy);
           this.$parent.$emit("energy-set", energy);
       }
   }
};
</script>
